/** Datos que comparten todos los tipos (viven en `library_items`). */
export interface Comunes {
  name: string;
  specialtyId: number | null;
  isEnglish: boolean;
  tags: string;
  description: string;
}

export const COMUNES_VACIOS: Comunes = {
  name: '',
  specialtyId: null,
  isEnglish: false,
  tags: '',
  description: '',
};

export function comunesDe(d: {
  name: string;
  specialtyId: number | null;
  isEnglish: boolean;
  tags: string[];
  description: string | null;
}): Comunes {
  return {
    name: d.name,
    specialtyId: d.specialtyId,
    isEnglish: d.isEnglish,
    tags: d.tags.join(', '),
    description: d.description ?? '',
  };
}

/** Cuerpo para la API: etiquetas como lista y descripción vacía como null. */
export function cuerpoComunes(c: Comunes, campos: CamposComunes = {}) {
  return {
    name: c.name.trim(),
    ...(campos.especialidad !== false && { specialtyId: c.specialtyId }),
    ...(campos.idioma !== false && { isEnglish: c.isEnglish }),
    ...(campos.etiquetas !== false && {
      tags: c.tags
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean),
    }),
    ...(campos.descripcion !== false && { description: c.description.trim() || null }),
  };
}

export interface CamposComunes {
  especialidad?: boolean;
  idioma?: boolean;
  etiquetas?: boolean;
  descripcion?: boolean;
}
